import { ComboboxList as BaseComboboxList } from '@reach/combobox'

import { styled } from '~/styled'

export const ComboboxList = styled(BaseComboboxList, {
  base: ['list-none', 'm-0', 'p-0', 'select-none']
})
